import { AnimatePresence } from "framer-motion";
import About from "pages/About";
import Home from "pages/Home";
import WorkPage from "pages/Work";
import { Route, Routes, useLocation } from "react-router-dom";
const AppRoutes = () => {
  const location = useLocation();
  return (
    <>
      <AnimatePresence>
        <Routes location={location} key={location.key}>
          <Route path={"/"} element={<Home />} />
          <Route path={"/about"} element={<About />} />
          <Route path={"/work"} element={<WorkPage />} />
        </Routes>
      </AnimatePresence>
    </>
  );
};

export default AppRoutes;
